import { useTranslation } from "react-i18next";
import { useStatusModal } from "../../context/StatusModalContext";

import CustomButton from "../CustomButton";

import "./style.scss";

const StatusModal = () => {
  const { modalState, closeStatusModal } = useStatusModal();
  const { isError, visible, goToHome, clearStorage, message } = modalState;
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className={isError ? "modal-icon error" : "modal-icon"}>
          <span>{isError ? "❗" : "✓"}</span>
        </div>
        <div className="modal-message">{message}</div>

        <CustomButton variant="outlined" onClick={closeStatusModal}>
          {clearStorage
            ? t("click_to_login")
            : goToHome
              ? t("go_home_page")
              : "Close"}
        </CustomButton>
      </div>
    </div>
  );
};

export default StatusModal;
